import { Node, mergeAttributes } from '@tiptap/core';
import { renderOpenApiHtml } from './openapi';

// Embeds an uploaded OpenAPI 3.x spec and renders a full auto-generated API
// reference. renderHTML emits only a marker (<div data-api-spec="<json>">) so
// the stored HTML stays small and round-trips; the docs site expands markers via
// expandApiSpecs() (before Shiki), and the editor previews live via a NodeView.

export const API_SPEC_MARKER = 'data-api-spec';

export const ApiSpec = Node.create({
  name: 'apiSpec',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      spec: { default: null, renderHTML: () => ({}) },
      title: { default: '', renderHTML: () => ({}) },
    };
  },

  parseHTML() {
    return [{
      tag: 'div[data-api-spec]',
      getAttrs: (el: any) => {
        try { return { spec: JSON.parse(el.getAttribute('data-api-spec') || 'null') }; } catch { return { spec: null }; }
      },
    }];
  },

  renderHTML({ HTMLAttributes, node }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-api-spec': JSON.stringify(node.attrs.spec), class: 'api-spec-marker' })];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement('div');
      dom.className = 'api-spec';
      dom.contentEditable = 'false';
      try {
        dom.innerHTML = node.attrs.spec ? renderOpenApiHtml(node.attrs.spec) : '<div class="oas oas-error">No spec.</div>';
      } catch {
        dom.innerHTML = '<div class="oas oas-error">Could not render spec.</div>';
      }
      return { dom };
    };
  },
});
